export default __webpack_public_path__ + "static/logo-wansite-light-5861908f3ff024ff1ab3bd0b2c8d014a.svg";